export class VisitorPromotionImageCommand {
  public link: string;
  public image: string;
  public isTop: Boolean;
  public isDisabled: Boolean;
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/commands/hub/visitor.promotion.image.command.ts